import actionDispatcher from './action-dispatcher';
import context from './context';
import eventSubscriber from './event-subscriber';
var lsqMarvinExternalAppIntegrator = {
  actionDispatcher: actionDispatcher,
  context: context,
  eventSubscriber: eventSubscriber
};
export default lsqMarvinExternalAppIntegrator;